export enum ChartSourceTypesEnum {
    single,
    multi
};
